import ManageFinance from "components/ManageFinance";
import NotFooterLayout from "layouts/NotFooterLayout";
import React from "react";

const ManageFinancePage = () => {
    return (
        <>
          <NotFooterLayout namePage="รายรับและการถอนเงิน" >
            <div className="layout-content">
            <ManageFinance />
            </div>
          </NotFooterLayout>
        </>
      );
};

export default ManageFinancePage;
